import React from "react";
import Follow from "../../components/Follow/FollowComponent";
import JoinCommunity from "../../components/JoinCommunity/JoinCommunity.component";
import AboutData from "./About.data";
import { Helmet } from "react-helmet";
import { Fade } from "react-reveal";
const parse = require("html-react-parser");

const About = () => {
  return (
    <Fade cascade duration={1000}>
      <section>
        <Helmet>
          <title>Who are we? Our Vision - Setu</title>
          <meta
            name="description"
            content="Made by creators, for creators. Your gateway into the Metaverse. Move content to Web 3.0 for free with Setu. Earn more, own your content, and expand your brand."
          />
        </Helmet>
        <div className="text-center  mx-4 sm:mx-4 md:mx-auto max-w-[558px]">
          <h1 className="heading font-bold mt-8">Who are we?</h1>
          <p className="text-base text-[#000000]  mt-4">
            Setu is built by content creators. We believe that content should be
            served without walls and that dependence on private platforms is bad
            for creators. We want creators to get ownership of their content.
          </p>
          <p className="text-base text-[#000000] mt-4">
            Therefore, we built a tool to help creators get into Web 3.0. It
            makes expansion to decentralised social media easier by moving your
            content library. Setu works on the DeSo protocol. This opens up new
            monetisation opportunities for creators such as creator tokens and
            NFTs.
          </p>
          <h3 className="text-xl font-bold mt-16 mb-4">
            How to get involved with Setu?
          </h3>
          <div className="flex mx-auto justify-center">
            <ul>
              {AboutData?.map((data, index) => (
                <li
                  key={index}
                  className="flex mt-3 items-center text-center ml-4"
                >
                  <img
                    className="w-[32px] h-[32px]"
                    src={data.icon}
                    alt="icon"
                  />
                  {parse(data.title)}
                </li>
              ))}
            </ul>
          </div>
          <p className="mt-6">
            Feel Free to reach out with any feedback, suggestions or just to say
            hello!
          </p>
        </div>
        <div className="my-20">
          <JoinCommunity
            title={"Join Our Conversations"}
            description={
              "Have any questions? Queries? Join our discord server to let us know  "
            }
            name={"JOIN_DISCORD_CLICK_FROM_ABOUT_PAGE"}
          />
        </div>
      </section>
    </Fade>
  );
};

export default About;
